import APIRequest from "./APIRequest";

export const getTickets = (params) => {
  return APIRequest.get(`admin/tickets`, params);
};

export const getTicketById = (ticketId) => {
  return APIRequest.get(`admin/tickets/${ticketId}`);
};

export const updateTicketStatus = ({ ticketId, status }) => {
  return APIRequest.patch(`admin/tickets/${ticketId}/status`, { status });
};


